module.exports = __webpack_public_path__ + "static/media/Plano2.80a7a427.jpg";